<template>
    <div class="coach" :style="{ paddingTop: `${height}px` }">
        <div class="coach-start">
            <StatusBar @getHeight="getHeight" />
            <div class="coach-hd">
                <div class="city" @click="jumpPageCity">
                    <img src="@/assets/vipCoach/v2/icon_dw@2x.png" />
                    <span>{{ currentCity.name ? currentCity.name : '' }}</span>
                </div>
                <h2>赚钱</h2>
            </div>
        </div>
        <div class="coach-wrap">
            <div class="tabs">
                <div class="tabs-hd">
                    <div
                        v-for="(item, index) in subjectItems"
                        v-show="item.goodsItems.length"
                        :key="index"
                        class="item"
                        :class="{ active: subjectIndex === index }"
                        @click="handleToggle(index)">
                        <span>{{ item.name }}</span>
                    </div>
                </div>
            </div>
            <p class="share-tips">分享便捷. 额外收入. 随时提现</p>
            <div class="invitation">
                <img src="@/assets/vipCoach/v2/icon_tbbj.png">
                <span>邀请学员购买，现金赚不停</span>
            </div>
            <div class="info">
                <table>
                    <thead>
                        <tr>
                            <td>推广商品</td>
                            <td>原价</td>
                            <td>分享价</td>
                            <td>佣金</td>
                        </tr>
                    </thead>
                    <tbody v-if="subjectIndex !== -1">
                        <tr
                            v-for="(item, index) in subjectItems[subjectIndex].goodsItems"
                            :key="index"
                            v-show="item.disableFlag">
                            <td>{{ item.goodsName }}</td>
                            <td>¥{{ item.payOrigPrice }}</td>
                            <td>¥{{ item.payConPrice }}</td>
                            <td>¥{{ item.coachCommission }}</td>
                        </tr>
                    </tbody>
                </table>
                <p class="tips">* 实际佣金以到账佣金为准</p>
                <img src="@/assets/vipCoach/v2/icon_fxzq.png" />
            </div>
            <van-swipe ref="swipe" class="swipe" indicator-color="white" :loop="false">
                <van-swipe-item v-for="item in swiperItems" :key="item">
                    <img :src="item">
                </van-swipe-item>
            </van-swipe>
            <h4>分享须知</h4>
            <div class="share-content">
                <p>1. 教练请根据地理位置选择商品进行分享。</p>
                <p>2. 教练分享给学员成功购买后可获得相应佣金，佣金可提现至微信钱包。</p>
                <p>3. 本商品为虚拟商品，学员购买后暂不支持退款，如有疑问请致电4006039603。</p>
            </div>
            <h4>如何推广</h4>
            <img class="tuiguang-image" src="@/assets/vipCoach/v2/icon_tgbz.png">
        </div>
        <div class="coach-footer">
            <van-button class="custom-btn" color="linear-gradient(90deg, #F89F4B 0%, #F55E35 100%)" round block
                @click="handleShowisPoster">立即分享</van-button>
        </div>
        <Share
            v-if="shareStatus"
            type="money"
            :isGoods="currentStatus"
            :subject="subjectItems[subjectIndex].subject"
            @cancel="shareStatus = false"
        />
        <EditInfo v-if="editInfoStatus" @cancel="editInfoStatus = false" />
    </div>
</template>

<script>
import { bindAppFn } from '../utils'
import { Dialog, Toast, Button, Swipe, SwipeItem, Sticky } from 'vant'
import Share from './components/share.vue'
import EditInfo from './components/editInfo.vue'
import StatusBar from './components/statusbar.vue'
import { getCoachSubjectGoods } from '../api';

export default {
    name: 'vipCoach',
    components: {
        [Button.name]: Button,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Sticky.name]: Sticky,
        Share,
        EditInfo,
        StatusBar
    },
    data() {
        return {
            // 吸顶距离
            height: 0,
            // 当前城市是否购买
            currentStatus: false,
            // 当前城市的code
            currentCity: {},
            items: [],
            subjectItems: [
                { name: '科目一', subject: 1, goodsItems: [], banner: ['100', '200', '201_202_203_204'] },
                { name: '科目二', subject: 2, goodsItems: [], banner: ['101', '103', '205_206', '207_208_209_210', '211_212_213_214'] },
                { name: '科目三', subject: 3, goodsItems: [], banner: ['104', '105', '106', '215_216_217_218', '219_220_221_222'] },
                { name: '科目四', subject: 4, goodsItems: [], banner: ['107', '223'] },
            ],
            swiperItems: [], // 轮播图片
            subjectIndex: 0,
            cityItems: {},
            // 控制海报显示隐藏
            shareStatus: false,
            // 信息编辑显示隐藏
            editInfoStatus: false
        }
    },
    methods: {
        // 获取APP凭证
        getToken() {
            return new Promise((resolve) => {
                bindAppFn({
                    name: 'app',
                    data: {
                        method: 'getCtlToken'
                    },
                    currentFnName: 'getCoachAppCtlToken',
                    callback: (e) => {
                        let token = ''
                        if (e && e !== 'null') {
                            try {
                                // andorid 处理方式
                                token = Object.values(JSON.parse(e))[0]
                            } catch (error) {
                                // ios处理方式
                                token = e
                            }
                        }
                        localStorage.setItem('ctl-token', token)
                        resolve(e)
                    }
                })
            })
        },
        // 获取城市
        getCityItems() {
            return new Promise((resolve) => {
                this.$api.getCoachSaleTargets().then(res => {
                    let arr = []
                    if (res.status) {
                        arr = res.result
                    }
                    resolve(arr)
                })
            })
        },
        // 获取当前用户个人信息的地址
        getUserInfoCity() {
            let city = null
            return new Promise((resolve) => {
                const { code, name } = this.$route.query
                if (code && name) {
                    resolve({ name, code })
                } else {
                    this.$api.getCoachUserInfoCity().then(res => {
                        // 有没有获取到城市
                        if (res.status && res.result) {
                            const { cityName, cityCode } = res.result
                            city = {
                                name: cityName,
                                code: cityCode
                            }
                            // 拿到个人信息中有城市直接存入缓存中
                            localStorage.setItem('vipCoachCity', JSON.stringify(city))
                        } else { // 没有拿到城市 就缓存中获取出来
                            const vipCoachCity = localStorage.getItem('vipCoachCity')
                            if (vipCoachCity) {
                                city = JSON.parse(vipCoachCity)
                            }
                        }
                        resolve(city)
                    })
                }

            })
        },
        // 获取当前城市
        getCurrentCity() {
            return new Promise(async (resolve) => {
                // 本地有就从本地获取
                let city = await this.getUserInfoCity()
                // 获取城市不是空就返回
                if (city) {
                    resolve(city)
                } else {
                    // 本地没有使用定位获取
                    const cityItems = await this.getCityItems()
                    bindAppFn({
                        name: 'app',
                        data: {
                            method: 'getCity'
                        },
                        currentFnName: 'getCoachAppCity',
                        callback: async (e) => {
                            let city = {}
                            let flag = true
                            try {
                                // 设置本地定位
                                city = JSON.parse(e)
                                localStorage.setItem('vipCoachCurrentCity', e)
                            } catch (e) {
                                // 解析失败 表示没有开启定位 拿查询出来的结果第一位使用
                                flag = await this.openSetting()
                                // 暂不开启的时候 默认设置第一个
                                if (flag) {
                                    city = cityItems[0]
                                }
                            }
                            if (flag) {
                                // 定位到有相关城市直接存入缓存中
                                localStorage.setItem('vipCoachCity', JSON.stringify(city))
                                resolve(city || {})
                            }
                        }
                    })
                }
            })
        },
        openSetting() {
            return new Promise((resolve) => {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '您还未打开定位权限，开启后可获取更多商品',
                    theme: 'round-button',
                    className: 'vip-coach-btn',
                    confirmButtonText: '开启',
                    cancelButtonText: '暂不开启'
                }).then(() => {
                    bindAppFn({
                        name: 'app',
                        data: {
                            method: 'openAppSettings'
                        }
                    })
                    resolve(false)
                }).catch(() => {
                    resolve(true)
                })
            })
        },
        // 查询当前城市是否支持考场跟套餐
        getCoachBuyAllowFlag() {
            return this.$api.getCoachBuyAllowFlag({
                cityCode: this.currentCity.code
            }).then(res => {
                if (res.status) {
                    this.currentStatus = res.result
                } else {
                    Toast.fail({ message: res.message })
                }
            })
        },
        // 获取当前城市的配置信息
        getCoachInitMakePage() {
            return getCoachSubjectGoods({
                cityCode: this.currentCity.code
            }).then(({ result, message, status }) => {
                if (status) {
                    const arr = ['subjectOne', 'subjectTwo', 'subjectThree', 'subjectFour']
                    Object.entries(result).forEach(([key, items]) => {
                        const index = arr.indexOf(key)
                        // 遍历所有商品 没有禁用则追加进去
                        items.forEach(item => {
                            if (item.disableFlag) {
                                this.subjectItems[index].goodsItems.push(item)
                            }
                        })
                    })
                    // 获取有内容的科目索引
                    const index = this.subjectItems.findIndex( item => (item.goodsItems.length))
                    this.handleToggle(index)
                } else {
                    Toast.fail({ message })
                }
            })
        },
        // 切换选项卡触发
        handleToggle(index) {
            this.subjectIndex = index
            // 不为-1表示全部都存在
            if (index === -1) {
                return
            }
            // 图片列表
            const { goodsItems, banner } = this.subjectItems[this.subjectIndex]
            const arr = []
            goodsItems.forEach(({ goodsCode, disableFlag }) => {
                if (disableFlag) {
                    const name = banner.find((name) => (name.includes(goodsCode)))
                    arr.push(require(`@/assets/vipCoach/v2/${name}.png`))
                }
            })
            // 切换轮播图片
            this.swiperItems = arr
        },
        // 跳转到海报页面
        async handleShowisPoster() {
            // 为-1 表示科目没得
            if (this.subjectIndex === -1) {
                Dialog.alert({
                    title: '温馨提示',
                    message: '抱歉，当前暂无商品可以分享，请联系客服。',
                })
                return
            }
            // token存在表示登录了 唤起分享功能
            if (localStorage.getItem('ctl-token')) {
                // 查询教练是否存在基本信息
                const flag = await this.getCoachInfo()
                if (flag) {
                    this.shareStatus = true
                } else {
                    this.editInfoStatus = true
                }
            } else {
                // 没有登录跳转到登录页
                bindAppFn({
                    name: 'app',
                    data: {
                        method: 'goLogin'
                    }
                })
            }
        },
        // 获取教练是否设置名字
        async getCoachInfo() {
            Toast.loading({ duration: 0, forbidClick: true })
            const res = await this.$api.getCoachUserInfo()
            let flag = false
            Toast.clear()
            if (res.status) {
                flag = !!res.result.userName
            } else {
                Toast.fail({ message: res.message })
            }
            return flag
        },
        jumpPageCity() {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'hiddenTabbar'
                }
            })
            this.$router.push({ name: 'vipCoachCity' })
        },
        getHeight(e) {
            this.height = e
        }
    },
    created() {
        bindAppFn({
            name: 'app',
            data: {
                method: 'showTabbar'
            }
        })
    },
    async mounted() {
        await this.getToken()
        const city = await this.getCurrentCity()
        const loading = Toast.loading({ duration: 0, forbidClick: true })
        this.currentCity = city
        await this.getCoachBuyAllowFlag()
        await this.getCoachInitMakePage()
        loading.clear()
    }
}
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
}

.coach {
    color: #333;
    font-weight: 400;
    line-height: 1;
    background: url('~@/assets/vipCoach/v2/bg_zq.png') no-repeat top left;
    background-color: #F3F4FB;
    background-size: 100%;

    &-wrap {
        padding: 60px 15px 100px 15px;
    }

    &-start {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 10;
        background: url('~@/assets/vipCoach/v2/bg_zq.png') no-repeat top left;
        background-size: 100%;
    }

    &-hd {
        display: flex;
        padding: 17px 97px 17px 15px;

        .city {
            display: flex;
            flex: 0 0 80px;
            align-items: center;
            font-size: 12px;

            img {
                margin-right: 3px;
                width: 12px;
            }
        }

        h2 {
            flex: 1;
            text-align: center;
            font-size: 20px;
            font-weight: 600;
        }
    }

    .share-tips {
        margin-top: 20px;
    }

    .invitation {
        margin-top: 18px;
        position: relative;
        padding: 26px 15px;
        font-size: 18px;
        font-weight: 600;

        img {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }

        span {
            position: relative;
        }
    }

    .info {
        position: relative;
        padding: 15px;
        font-size: 15px;
        background-color: #fff;
        border-radius: 0px 0px 5px 5px;

        table {
            width: 100%;
            border-collapse: collapse;
            text-align: center;

            td {
                border-bottom: 1px solid rgba(235, 236, 244, 0.8);
            }

            thead td {
                padding-bottom: 8px;
            }

            tbody td {
                padding: 12px 0 8px 0;
                &:nth-child(1) {
                    width: 100px;
                }
                &:nth-child(2) {
                    text-decoration: line-through;
                }

                &:nth-child(3),
                &:nth-child(4) {
                    color: #FE4A48;
                }
            }
        }

        .tips {
            margin-top: 15px;
            text-align: center;
            font-size: 14px;
        }

        img {
            position: absolute;
            top: -4px;
            right: -4px;
            width: 53px;
        }
    }

    .tabs {
        &-hd {
            display: flex;
            .item {
                margin-right: 20px;
                height: 18px;
                line-height: 18px;
                font-size: 15px;
                transition: all 0.5s ease;
                &.active {
                    position: relative;
                    font-weight: 600;
                    transform: scale(1.1);
                    transform-origin: left;

                    span {
                        position: relative;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 5px;
                        background: #00CA84;
                        border-radius: 3px;
                    }
                }
            }
        }
    }

    .swipe {
        margin-top: 10px;
        overflow: hidden;
        img {
            max-width: 100%;
            border-radius: 5px;
        }
        /deep/ .van-swipe__indicators {
            bottom: 20px;
            .van-swipe__indicator--active {
                width: 15px;
                border-radius: 3px;
            }
        }
    }

    h4 {
        margin-top: 20px;
        font-size: 18px;
        font-weight: 600;
    }

    .share-content {
        margin-top: 10px;
        padding: 13px 15px;
        font-size: 14px;
        line-height: 24px;
        border-radius: 5px;
        background-color: #Fff;
    }

    .tuiguang-image {
        margin-top: 10px;
        width: 100%;
    }

    .coach-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 10;
        padding: 10px 15px;
        width: 100%;
        background: #f3f4fa;
    }

    .custom-btn {
        height: 45px;
        line-height: 45px;
        font-size: 18px;
        font-weight: 600;
    }
}</style>
